import styled from 'styled-components'

export const ModalRoot = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(35, 31, 32, 0.4);
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 1;
  backdrop-filter: blur(undefined);
  -webkit-backdrop-filter: blur(undefined);
`

export const ModalContainer = styled.div`
  -webkit-box-shadow: 0px 0px 10px 0px rgb(147 142 142 / 75%);
  -moz-box-shadow: 0px 0px 10px 0px rgb(147 142 142 / 75%);
  box-shadow: 0px 0px 10px 0px rgb(147 142 142 / 75%);
  padding: 0px 45px;
  width: calc(100% - 30px);
  max-width: 940px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 10px;
  position: relative;
  max-height: 750px;
  overflow: auto;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  &::-webkit-scrollbar:vertical {
    width: 5px;
  }
  &::-webkit-scrollbar-button:increment,
  &::-webkit-scrollbar-button {
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #797979;
    border-radius: 20px;
    border: 0px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track-piece:end {
    background: transparent;
    margin-bottom: 50px;
  }
  &::-webkit-scrollbar-track-piece:start {
    background: transparent;
    margin-top: 50px;
  }
`

export const ModalClose = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .close {
    cursor: pointer;
    font-weight: 200;
    font-size: 35px;
    margin-right: 10px;
    padding: 0px 3px;
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const ModalTitle = styled.h6`
  margin: 0;
  margin-top: 66px;
  font-size: 28px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.primary};
  font-family: 'Work Sans';
`
